// extracted by mini-css-extract-plugin
export default {"ads_container":"Ads_ads_container__YUbXI","adImg_container":"Ads_adImg_container__nI+La","ads_head":"Ads_ads_head__4qxEr","ad_card":"Ads_ad_card__9ka5H"};